import {
  UPDATE_MYTRIP_LOADER,
  UPDATE_MYTRIP_ACTIVE_TAB,
  UPDATE_MYTRIP_HEADERS,
  UPDATE_MYTRIP_DATA,
  UPDATE_MYTRIP_DETAILS_QUERY_PARAMS,
  UPDATE_MYTRIP_DETAILS_DATA,
  UPDATE_CANCELLATION_DATA,
  UPDATE_CANCELLATION_ACTIVE_TAB,
  UPDATE_CANCELLATION_REFUND_MODE,
  UPDATE_CANCELLATION_REFUND_DATA,
  UPDATE_WALLET_DATA,
  UPDATE_WALLET_STATEMENT_LOADER,
  UPDATE_WALLET_BREAKUP_DATA,
  UPDATE_RECHARGE_STATUS,
  UPDATE_MODIFY_ACTIVE_TAB,
  UPDATE_MODIFY_HOTEL_DETAILS_DATA,
  UPDATE_MODIFY_DETAILS_DATA,
  UPDATE_MODIFY_STATUS,
  UPDATE_USER_SETTING_DATA,
  UPDATE_SUCCESS_NAME_MESSAGE,
  UPDATE_ERROR_NAME_MESSAGE,
  UPDATE_AADHAR_NUMBER,
  UPDATE_WALLET_TYPE,
  UPDATE_NEFT_DETAILS,
  UPDATE_NEFT_DETAILS_LOADER,
  UPDATE_LOYALTY_AGREEMENT_DATE,
  UPDATE_LOYALTY_AGREEMENT_DOC,
  UPDATE_GCC_USER_SETTING_DATA,
  UPDATE_FORMFIELD_DATA,
  UPDATE_ROW_FIELDS_DATA,
  UPDATE_CARDS_MEMO,
  UPDATE_CARDS_DATA,
  UPDATE_AIS_CARDS_DATA,
  UPDATE_GST_FORM_ROW,
} from './myaccount-constants';

import {
  ACTION_UPDATE_MYTRIP_LOADER,
  ACTION_UPDATE_MYTRIP_ACTIVE_TAB,
  ACTION_UPDATE_MYTRIP_HEADERS,
  ACTION_UPDATE_MYTRIP_DATA,
  ACTION_UPDATE_MYTRIP_DETAILS_QUERY_PARAMS,
  ACTION_UPDATE_MYTRIP_DETAILS_DATA,
  ACTION_UPDATE_CANCELLATION_DATA,
  ACTION_UPDATE_CANCELLATION_ACTIVE_TAB,
  ACTION_UPDATE_CANCELLATION_REFUND_MODE,
  ACTION_UPDATE_CANCELLATION_REFUND_DATA,
  ACTION_UPDATE_WALLET_DATA,
  ACTION_UPDATE_WALLET_STATEMENT_LOADER,
  ACTION_UPDATE_WALLET_BREAKUP_DATA,
  ACTION_UPDATE_RECHARGE_STATUS,
  ACTION_UPDATE_MODIFY_ACTIVE_TAB,
  ACTION_UPDATE_MODIFY_HOTEL_DETAILS_DATA,
  ACTION_UPDATE_MODIFY_DETAILS_DATA,
  ACTION_UPDATE_MODIFY_STATUS,
  ACTION_UPDATE_USER_SETTING_DATA,
  ACTION_UPDATE_SUCCESS_NAME_MESSAGE,
  ACTION_UPDATE_ERROR_NAME_MESSAGE,
  ACTION_UPDATE_AADHAR_NUMBER,
  ACTION_UPDATE_WALLET_TYPE,
  ACTION_UPDATE_NEFT_DETAILS,
  ACTION_UPDATE_NEFT_DETAILS_LOADER,
  ACTION_GET_LOYALTY_AGREEMENT_DATE,
  ACTION_GET_LOYALTY_AGREEMENT_DOC,
  ACTION_UPDATE_GCC_USER_SETTING_DATA,
  ACTION_UPDATE_FORMFIELD_DATA,
  ACTION_UPDATE_ROW_FIELDS_DATA,
  ACTION_UPDATE_SHOW_CARDS_MEMO,
  ACTION_ADD_CARDS_DATA,
  ACTION_UPDATE_AIS_CARDS_DATA,
  ACTION_UPDATE_GST_FORM_ROW,
} from './myaccount-types';

export function updateMyTripsLoader(
  actionData: ACTION_UPDATE_MYTRIP_LOADER['actionData'],
): ACTION_UPDATE_MYTRIP_LOADER {
  return {
    type: UPDATE_MYTRIP_LOADER,
    actionData,
  };
}

export function updateWalletTypeTab(
  actionData: ACTION_UPDATE_WALLET_TYPE['actionData'],
): ACTION_UPDATE_WALLET_TYPE {
  return {
    type: UPDATE_WALLET_TYPE,
    actionData,
  };
}

export function updateActiveTab(
  actionData: ACTION_UPDATE_MYTRIP_ACTIVE_TAB['actionData'],
): ACTION_UPDATE_MYTRIP_ACTIVE_TAB {
  return {
    type: UPDATE_MYTRIP_ACTIVE_TAB,
    actionData,
  };
}

export function updateMyTripsHeader(
  actionData: ACTION_UPDATE_MYTRIP_HEADERS['actionData'],
): ACTION_UPDATE_MYTRIP_HEADERS {
  return {
    type: UPDATE_MYTRIP_HEADERS,
    actionData,
  };
}

export function updateMyTripsData(
  actionData: ACTION_UPDATE_MYTRIP_DATA['actionData'],
): ACTION_UPDATE_MYTRIP_DATA {
  return {
    type: UPDATE_MYTRIP_DATA,
    actionData,
  };
}

export function updateMyTripDetailsQueryAction(
  actionData: ACTION_UPDATE_MYTRIP_DETAILS_QUERY_PARAMS['actionData'],
): ACTION_UPDATE_MYTRIP_DETAILS_QUERY_PARAMS {
  return {
    type: UPDATE_MYTRIP_DETAILS_QUERY_PARAMS,
    actionData,
  };
}

export function updateMyTripsDetailsData(
  actionData: ACTION_UPDATE_MYTRIP_DETAILS_DATA['actionData'],
): ACTION_UPDATE_MYTRIP_DETAILS_DATA {
  return {
    type: UPDATE_MYTRIP_DETAILS_DATA,
    actionData,
  };
}

export function updateCancellationData(
  actionData: ACTION_UPDATE_CANCELLATION_DATA['actionData'],
): ACTION_UPDATE_CANCELLATION_DATA {
  return {
    type: UPDATE_CANCELLATION_DATA,
    actionData,
  };
}

export function updateActiveCancellationTab(
  actionData: ACTION_UPDATE_CANCELLATION_ACTIVE_TAB['actionData'],
): ACTION_UPDATE_CANCELLATION_ACTIVE_TAB {
  return {
    type: UPDATE_CANCELLATION_ACTIVE_TAB,
    actionData,
  };
}

export function updateCancellationRefundMode(
  actionData: ACTION_UPDATE_CANCELLATION_REFUND_MODE['actionData'],
): ACTION_UPDATE_CANCELLATION_REFUND_MODE {
  return {
    type: UPDATE_CANCELLATION_REFUND_MODE,
    actionData,
  };
}

export function updateCancellationRefundData(
  actionData: ACTION_UPDATE_CANCELLATION_REFUND_DATA['actionData'],
): ACTION_UPDATE_CANCELLATION_REFUND_DATA {
  return {
    type: UPDATE_CANCELLATION_REFUND_DATA,
    actionData,
  };
}

export function updateWalletStatementLoader(
  actionData: ACTION_UPDATE_WALLET_STATEMENT_LOADER['actionData'],
): ACTION_UPDATE_WALLET_STATEMENT_LOADER {
  return {
    type: UPDATE_WALLET_STATEMENT_LOADER,
    actionData,
  };
}

export function updateWalletData(
  actionData: ACTION_UPDATE_WALLET_DATA['actionData'],
): ACTION_UPDATE_WALLET_DATA {
  return {
    type: UPDATE_WALLET_DATA,
    actionData,
  };
}

export function updateWalletBreakupData(
  actionData: ACTION_UPDATE_WALLET_BREAKUP_DATA['actionData'],
): ACTION_UPDATE_WALLET_BREAKUP_DATA {
  return {
    type: UPDATE_WALLET_BREAKUP_DATA,
    actionData,
  };
}

export function updateRechargeStatus(
  actionData: ACTION_UPDATE_RECHARGE_STATUS['actionData'],
): ACTION_UPDATE_RECHARGE_STATUS {
  return {
    type: UPDATE_RECHARGE_STATUS,
    actionData,
  };
}

export function updateActiveModifyTab(
  actionData: ACTION_UPDATE_MODIFY_ACTIVE_TAB['actionData'],
): ACTION_UPDATE_MODIFY_ACTIVE_TAB {
  return {
    type: UPDATE_MODIFY_ACTIVE_TAB,
    actionData,
  };
}

export function updateMyTripsModifyHotelDetailsData(
  actionData: ACTION_UPDATE_MODIFY_HOTEL_DETAILS_DATA['actionData'],
): ACTION_UPDATE_MODIFY_HOTEL_DETAILS_DATA {
  return {
    type: UPDATE_MODIFY_HOTEL_DETAILS_DATA,
    actionData,
  };
}

export function updateMyTripsModifyDetailsData(
  actionData: ACTION_UPDATE_MODIFY_DETAILS_DATA['actionData'],
): ACTION_UPDATE_MODIFY_DETAILS_DATA {
  return {
    type: UPDATE_MODIFY_DETAILS_DATA,
    actionData,
  };
}

export function updateModifyStatus(
  actionData: ACTION_UPDATE_MODIFY_STATUS['actionData'],
): ACTION_UPDATE_MODIFY_STATUS {
  return {
    type: UPDATE_MODIFY_STATUS,
    actionData,
  };
}

export function updateUserSettingData(
  actionData: ACTION_UPDATE_USER_SETTING_DATA['actionData'],
): ACTION_UPDATE_USER_SETTING_DATA {
  return {
    type: UPDATE_USER_SETTING_DATA,
    actionData,
  };
}

export function updateGccUserSettingData(
  actionData: ACTION_UPDATE_GCC_USER_SETTING_DATA['actionData'],
): ACTION_UPDATE_GCC_USER_SETTING_DATA {
  return {
    type: UPDATE_GCC_USER_SETTING_DATA,
    actionData,
  };
}

export function updateSuccessNameMessage(
  actionData: ACTION_UPDATE_SUCCESS_NAME_MESSAGE['actionData'],
): ACTION_UPDATE_SUCCESS_NAME_MESSAGE {
  return {
    type: UPDATE_SUCCESS_NAME_MESSAGE,
    actionData,
  };
}

export function updateErrorNameMessage(
  actionData: ACTION_UPDATE_ERROR_NAME_MESSAGE['actionData'],
): ACTION_UPDATE_ERROR_NAME_MESSAGE {
  return {
    type: UPDATE_ERROR_NAME_MESSAGE,
    actionData,
  };
}

export function updateAadharNumberAction(
  actionData: ACTION_UPDATE_AADHAR_NUMBER['actionData'],
): ACTION_UPDATE_AADHAR_NUMBER {
  return {
    type: UPDATE_AADHAR_NUMBER,
    actionData,
  };
}

export function updateNeftDetailsAction(
  actionData: ACTION_UPDATE_NEFT_DETAILS['actionData'],
): ACTION_UPDATE_NEFT_DETAILS {
  return {
    type: UPDATE_NEFT_DETAILS,
    actionData,
  };
}

export function updateNeftDetailsLoaderAction(
  actionData: ACTION_UPDATE_NEFT_DETAILS_LOADER['actionData'],
): ACTION_UPDATE_NEFT_DETAILS_LOADER {
  return {
    type: UPDATE_NEFT_DETAILS_LOADER,
    actionData,
  };
}

export function getLoyaltyAgreementDate(
  actionData: ACTION_GET_LOYALTY_AGREEMENT_DATE['actionData'],
): ACTION_GET_LOYALTY_AGREEMENT_DATE {
  return {
    type: UPDATE_LOYALTY_AGREEMENT_DATE,
    actionData,
  };
}

export function getLoyaltyAgreementDoc(
  actionData: ACTION_GET_LOYALTY_AGREEMENT_DATE['actionData'],
): ACTION_GET_LOYALTY_AGREEMENT_DOC {
  return {
    type: UPDATE_LOYALTY_AGREEMENT_DOC,
    actionData,
  };
}

export function updateFormFieldsData(
  actionData: ACTION_UPDATE_FORMFIELD_DATA['actionData'],
): ACTION_UPDATE_FORMFIELD_DATA {
  return {
    type: UPDATE_FORMFIELD_DATA,
    actionData,
  };
}

export function updateRowFieldsData(
  actionData: ACTION_UPDATE_ROW_FIELDS_DATA['actionData'],
): ACTION_UPDATE_ROW_FIELDS_DATA {
  return {
    type: UPDATE_ROW_FIELDS_DATA,
    actionData,
  };
}

export function updateShowCardsMemo(
  actionData: ACTION_UPDATE_SHOW_CARDS_MEMO['actionData'],
): ACTION_UPDATE_SHOW_CARDS_MEMO {
  return {
    type: UPDATE_CARDS_MEMO,
    actionData,
  };
}

export function addCardsData(actionData: ACTION_ADD_CARDS_DATA): ACTION_ADD_CARDS_DATA {
  return {
    type: UPDATE_CARDS_DATA,
    actionData,
  };
}

export function updateAisCardsData(
  actionData: ACTION_UPDATE_AIS_CARDS_DATA,
): ACTION_UPDATE_AIS_CARDS_DATA {
  return {
    type: UPDATE_AIS_CARDS_DATA,
    actionData,
  };
}

export function updateGstFormRow(
  actionData: ACTION_UPDATE_GST_FORM_ROW,
): ACTION_UPDATE_GST_FORM_ROW {
  return {
    type: UPDATE_GST_FORM_ROW,
    actionData,
  };
}
